import { CatLifeStageKey } from "@/domains/cats/CatAge";
import KittenImage from "@/assets/images/lifestages/kitten.webp";
import MatureAdultImage from "@/assets/images/lifestages/mature-adult.webp";
import OgpKittenImage from "@/assets/images/lifestages/ogp-kitten.jpg";
import OgpMatureAdultImage from "@/assets/images/lifestages/ogp-mature-adult.jpg";
import OgpSeniorImage from "@/assets/images/lifestages/ogp-senior.jpg";
import OgpYoungAdultImage from "@/assets/images/lifestages/ogp-young-adult.jpg";
import SeniorImage from "@/assets/images/lifestages/senior.webp";
import YoungAdultImage from "@/assets/images/lifestages/young-adult.webp";

export const LIFE_STAGE_DESCRIPTIONS: Record<
  CatLifeStageKey,
  readonly string[]
> = {
  [CatLifeStageKey.Kitten]: [
    "からだと骨格が大きく成長する時期。",
    "栄養バランスの良い食事が大切です。",
  ],
  [CatLifeStageKey.YoungAdult]: [
    "心身ともに安定した時期。",
    "体重管理と適度な運動を意識しましょう。",
  ],
  [CatLifeStageKey.MatureAdult]: [
    "からだの変化が出やすくなる時期。",
    "定期的な健康チェックがおすすめです。",
  ],
  [CatLifeStageKey.Senior]: [
    "からだをいたわる時期。",
    "食事や水分の変化に気を配りましょう。",
  ],
};

export const LIFE_STAGE_IMAGES: Record<CatLifeStageKey, string> = {
  [CatLifeStageKey.Kitten]: KittenImage,
  [CatLifeStageKey.YoungAdult]: YoungAdultImage,
  [CatLifeStageKey.MatureAdult]: MatureAdultImage,
  [CatLifeStageKey.Senior]: SeniorImage,
};

export const LIFE_STAGE_OGP_IMAGES: Record<CatLifeStageKey, string> = {
  [CatLifeStageKey.Kitten]: OgpKittenImage,
  [CatLifeStageKey.YoungAdult]: OgpYoungAdultImage,
  [CatLifeStageKey.MatureAdult]: OgpMatureAdultImage,
  [CatLifeStageKey.Senior]: OgpSeniorImage,
};

export const LIFE_STAGE_CARE_POINTS: Record<
  CatLifeStageKey,
  readonly string[]
> = {
  [CatLifeStageKey.Kitten]: [
    "成長に必要なエネルギーが多いため、子猫用と表示されたフードを体重の増え方を見ながら与えます。",
    "ワクチン接種や避妊・去勢手術の時期について、早めに獣医師と相談しておきましょう。",
    "人や環境に慣れる社会化の時期です。遊びを通して運動と信頼関係づくりを進めます。",
  ],
  [CatLifeStageKey.YoungAdult]: [
    "避妊・去勢後は太りやすくなるため、体重と体型を定期的に確認してごはん量を調整します。",
    "年1回の健康診断で、健康なときの数値を記録しておくと変化に気づきやすくなります。",
    "運動不足になりがちな室内飼いでは、毎日の遊びで活動量を確保しましょう。",
  ],
  [CatLifeStageKey.MatureAdult]: [
    "活動量が落ちて体重が増えやすくなる一方、筋肉量は減りはじめます。体重だけでなく体型も見ます。",
    "年1回以上の健康診断と血液検査で、見えにくい変化を早めに捉えましょう。",
    "歯石や歯肉炎が増える時期です。口臭や食べ方の変化があれば受診を検討します。",
  ],
  [CatLifeStageKey.Senior]: [
    "体重減少や筋肉量の低下が起こりやすくなります。食欲・飲水量・排尿の変化を日々観察しましょう。",
    "半年ごとの健康診断が推奨される時期です。気になる変化は早めに獣医師へ相談します。",
    "段差の少ない環境や温かい寝床など、からだへの負担を減らす工夫が快適さにつながります。",
  ],
};
